import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    CircularProgress,
} from "@mui/material";

// Components
import Icon from "@/theme/vectors/bundle";

const AttributeConfirmDialog = ({ open, mode, onClose, onSave, onDiscard, saving, t }) => {
    return (
        <Dialog
            open={open}
            onClose={saving ? null : onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                {mode === 'save' 
                    ? t('product.detail.saveAttributesTitle', 'Save Attributes?') 
                    : t('product.detail.discardAttributesTitle', 'Discard Changes?')}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {mode === 'save' 
                        ? t('product.detail.saveAttributesWarning', 'Once attributes are saved, they cannot be modified later as this would affect product variants and orders. Are you sure you want to save these attributes?') 
                        : t('product.detail.discardAttributesWarning', 'You have unsaved attribute changes. Are you sure you want to discard them?')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={onClose} 
                    color="primary"
                    disabled={saving}
                >
                    {t('common.cancel')}
                </Button>
                {mode === 'save' ? (
                    <Button 
                        onClick={onSave} 
                        variant="contained" 
                        color="primary"
                        startIcon={saving ? <CircularProgress size={20} color="inherit" /> : <Icon name="save" />}
                        disabled={saving}
                    >
                        {saving ? t('product.detail.processingAttributes', 'Processing...') : t('product.detail.saveAttributes', 'Save Attributes')}
                    </Button>
                ) : (
                    <Button 
                        onClick={onDiscard} 
                        variant="contained" 
                        color="error"
                        disabled={saving}
                    >
                        {t('common.discard')}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default AttributeConfirmDialog;